import { EventSelector, decodeFromAbi } from '@aztec/aztec.js/abi';
import { TxHash } from '@aztec/aztec.js/tx';
import { bytesToHex } from '@train-protocol/sdk';
import { TrainContract } from '../../artifacts/Train';
import { getUserLockDetails } from './getUserLockDetails';
export async function recoverSwap(rpcUrl, node, signer, txHash, network) {
    if (!/^0x[a-fA-F0-9]{1,64}$/.test(txHash))
        throw new Error('Invalid transaction hash format');
    const { logs } = await node.getPublicLogs({
        txHash: TxHash.fromString(txHash),
    });
    if (!logs.length)
        throw new Error('Transaction not found');
    const eventDef = TrainContract.events.UserLocked;
    for (const log of logs) {
        const emittedFields = log.log.getEmittedFields();
        if (emittedFields.length === 0)
            continue;
        const selectorField = emittedFields[emittedFields.length - 1];
        const selector = EventSelector.fromField(selectorField);
        if (selector.toString() !== eventDef.eventSelector.toString())
            continue;
        const decoded = decodeFromAbi([eventDef.abiType], log.log.fields);
        const eventHashlock = bytesToHex(Array.from(decoded.hashlock).map(Number));
        const eventToken = decoded.token.toString();
        const token = network.tokens.find(t => t.contract?.toLowerCase() === eventToken.toLowerCase());
        const decimals = token?.decimals ?? 18;
        const result = await getUserLockDetails(rpcUrl, node, signer, {
            id: eventHashlock,
            contractAddress: network.trainContract,
            decimals,
            txId: txHash,
            chainId: network.chainId,
        });
        if (!result)
            throw new Error('Lock not found for recovered hashlock');
        return result;
    }
    throw new Error('This transaction does not contain a swap lock');
}
